import { useRef as U, useState as $, useCallback as H, useMemo as j } from "react";
import { useFloating as z, autoUpdate as A, useHover as B, safePolygon as K, useFocus as L, useDismiss as q, useRole as G, useTransitionStatus as J, useInteractions as Q, useMergeRefs as X, offset as Y, flip as Z, shift as ee, limitShift as te, size as ie, arrow as le } from "@floating-ui/react";
import { arrowDimensions as r } from "../constants/arrowDimensions.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "###DS_VERSION_PLACEHOLDER###");
const oe = _ref => {
    let {
      arrowRef: u,
      disableFlip: h,
      disablePositionShift: p,
      height: n,
      width: s,
      maxHeight: o,
      maxWidth: a
    } = _ref;
    return [Y(r.height + 4), !h && Z(), !p && ee({
      limiter: te({
        offset: r.width + r.padding
      })
    }), ie({
      apply(_ref2) {
        let {
          availableWidth: g,
          availableHeight: f,
          elements: m
        } = _ref2;
        Object.assign(m.floating.style, {
          height: n != null ? n : "unset",
          width: s != null ? s : "unset",
          maxHeight: o != null ? o : "max(min-content, ".concat(f, "px)"),
          maxWidth: a != null ? a : "".concat(g, "px")
        });
      }
    }), le({
      element: u,
      padding: r.padding
    })];
  },
  ne = _ref3 => {
    let {
      disableEscClose: u,
      disableFlip: h,
      disableHover: p,
      disablePositionShift: n,
      disablePressOutsideClose: s,
      disableTouchInteraction: o,
      externalRef: a,
      height: g,
      maxHeight: f,
      maxWidth: m,
      initialOpenState: D,
      open: d,
      placement: M,
      width: W,
      openCallback: c,
      closeCallback: i
    } = _ref3;
    const b = U(null),
      [w, R] = $(D),
      e = typeof d != "boolean",
      v = e ? w : d,
      I = H(l => {
        if (e) return R(l);
        l ? c == null || c() : i == null || i();
      }, [i, e, c]),
      {
        refs: x,
        floatingStyles: S,
        context: t
      } = z({
        open: v,
        onOpenChange: I,
        placement: M,
        middleware: oe({
          arrowRef: b,
          disableFlip: h,
          disablePositionShift: n,
          height: g,
          width: W,
          maxHeight: f,
          maxWidth: m
        }),
        whileElementsMounted: A
      }),
      k = B(t, {
        enabled: e && !p,
        handleClose: K(),
        mouseOnly: !o
      }),
      N = L(t, {
        enabled: e,
        keyboardOnly: !o
      }),
      T = q(t, {
        escapeKey: !u,
        outsidePress: !s
      }),
      V = G(t, {
        role: "tooltip"
      }),
      {
        isMounted: _,
        status: O
      } = J(t),
      {
        getReferenceProps: P,
        getFloatingProps: y
      } = Q([k, N, T, V]),
      E = X([x.setFloating, a]),
      F = H(l => {
        var C;
        if ((C = l == null ? void 0 : l.stopPropagation) == null || C.call(l), e) return R(!1);
        i == null || i();
      }, [i, e]);
    return j(() => ({
      arrowRef: b,
      context: t,
      floatingStyles: S,
      getReferenceProps: P,
      getFloatingProps: y,
      isMounted: _,
      mergedFloatingRef: E,
      refs: x,
      status: O,
      uncontrolledOpen: w,
      controlledOpen: d,
      isUncontrolledMode: e,
      handleClose: F
    }), [b, t, S, P, y, _, E, x, O, w, d, e, F]);
  };
export { ne as useTooltip };